import { Box, type ButtonProps, Icon, Button, Text } from '@chakra-ui/react'
import { useColorPalette } from './color-palette-context';
import { useColorMode } from './color-mode';

interface PromptButtonProps extends ButtonProps {
  icon: React.ReactElement,
  onPromptClick: (prompt: string) => void,
  fontFamily?: string,
  headerText?: string,
}

export const PromptButton = (props: PromptButtonProps) => {
  const { icon, children, onPromptClick, fontFamily, headerText, ...rest } = props
  const handleClick = () => {
    onPromptClick(children as string);
  };

  const {colorPalette} = useColorPalette();
  const { colorMode } = useColorMode();

  return (
    <Button
      variant={"subtle"}
      bgColor={colorPalette == 'gray' && colorMode == 'dark' ? '#262626' : ''}
      _hover={{bg: colorPalette == 'gray' && colorMode == 'dark' ? 'fg.muted/50' : ''}}
      minH={{ base: '100px', md: '200px' }}
      alignItems="flex-start"
      p="3"
      textStyle="md"
      fontWeight="medium"
      whiteSpace="normal"
      textAlign="start"
      onClick={handleClick}
      fontFamily={fontFamily}
      justifyContent={'flex-start'}
      flexDirection={'column'}
      {...rest}
    >
        <Text fontSize={'lg'} fontWeight={'600'} >{headerText}</Text>
      {children}
      <Box pos="absolute" bottom="3" insetEnd="3">
        <Icon size="lg" color="colorPalette.fg/50">
          {icon}
        </Icon>
      </Box>
    </Button>
  )
}